import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function HistoryKaizenTab() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await axios.get(
        "/api/maintenance/kaizen/history",
      );
      console.log(res.data);
      setData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const exportToExcel = () => {
    const exportData = filtered.map((row, index) => ({
      No: index + 1,
      Tanggal: new Date(row.tanggal).toLocaleDateString("id-ID"),
      Mesin: row.mesin,
      PIC: row.pic,
      Material: row.material_name,
      Qty: row.qty,
      Keterangan: row.note,
      CreatedAt: new Date(row.created_at).toLocaleString("id-ID"),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "History Kaizen");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      data,
      `History_Kaizen_${new Date().toISOString().split("T")[0]}.xlsx`,
    );
  };
  const filtered = data.filter((row) => {
    const keyword = search.toLowerCase();

    const rowDate = row.tanggal
      ? new Date(row.tanggal).toISOString().split("T")[0]
      : "";

    const matchKeyword =
      row.mesin?.toLowerCase().includes(keyword) ||
      row.pic?.toLowerCase().includes(keyword) ||
      row.material_name?.toLowerCase().includes(keyword);

    const matchDateFrom = !dateFrom || rowDate >= dateFrom;

    const matchDateTo = !dateTo || rowDate <= dateTo;
    console.log(row.tanggal);
    return matchKeyword && matchDateFrom && matchDateTo;
  });

  return (
    <div className="container-fluid py-2">
      <div className="card shadow border-0">
        <div className="card-body">
          <div className="card border">
            {/* HEADER */}
            <div
              className="card-header text-white"
              style={{ background: "#1e3a8a" }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <i className="fas fa-history me-2"></i>
                  History Kaizen
                </h5>

                <span className="badge bg-light text-primary">
                  Total Data : {filtered.length}
                </span>
              </div>
            </div>

            {/* SEARCH */}
            <div className="card-body pb-0">
              <div className="row mb-3 align-items-end">
                <div className="col-md-4">
                  <label className="form-label fw-bold">Cari Data</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="🔍 Cari Mesin / PIC / Material..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      border: "1px solid #1e3a8a",
                    }}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label fw-bold">Dari Tanggal</label>

                  <input
                    type="date"
                    className="form-control"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label fw-bold">Sampai Tanggal</label>

                  <input
                    type="date"
                    className="form-control"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                  />
                </div>

                <div className="col-md-4 text-end">
                  <button className="btn btn-success" onClick={exportToExcel}>
                    <i className="fas fa-file-excel me-2"></i>
                    Export Excel
                  </button>
                </div>
              </div>
            </div>

            {/* TABLE */}
            <div
              className="table-responsive px-3 pb-3"
              style={{
                maxHeight: "550px",
                overflowY: "auto",
              }}
            >
              <table
                className="table table-bordered table-hover align-middle"
                style={{
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  <tr>
                    <th
                      style={{
                        background: "#1e3a8a",
                        color: "#fff",
                        width: "60px",
                        textAlign: "center",
                      }}
                    >
                      NO
                    </th>

                    <th
                      style={{
                        background: "#1e3a8a",
                        color: "#fff",
                      }}
                    >
                      TANGGAL
                    </th>

                    <th
                      style={{
                        background: "#1e3a8a",
                        color: "#fff",
                      }}
                    >
                      MESIN
                    </th>

                    <th
                      style={{
                        background: "#1e3a8a",
                        color: "#fff",
                      }}
                    >
                      PIC
                    </th>

                    <th
                      style={{
                        background: "#1e3a8a",
                        color: "#fff",
                      }}
                    >
                      MATERIAL
                    </th>

                    <th
                      style={{
                        background: "#1e3a8a",
                        color: "#fff",
                        textAlign: "center",
                      }}
                    >
                      QTY
                    </th>

                    <th
                      style={{
                        background: "#1e3a8a",
                        color: "#fff",
                      }}
                    >
                      KETERANGAN
                    </th>

                    <th
                      style={{
                        background: "#1e3a8a",
                        color: "#fff",
                      }}
                    >
                      CREATED AT
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {filtered.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        Tidak ada data ditemukan
                      </td>
                    </tr>
                  ) : (
                    filtered.map((row, index) => (
                      <tr key={row.id}>
                        <td className="text-center fw-bold">{index + 1}</td>

                        <td>
                          {new Date(row.tanggal).toLocaleDateString("id-ID")}
                        </td>

                        <td className="cell-left">
                          <span className="fw-bold">{row.mesin}</span>
                        </td>

                        <td>{row.pic}</td>

                        <td>
                          <span className="fw-bold text-dark">
                            {row.material_name}
                          </span>
                        </td>

                        <td className="text-center">
                          <span
                            className="badge bg-primary"
                            style={{
                              fontSize: "14px",
                              minWidth: "40px",
                            }}
                          >
                            {row.qty}
                          </span>
                        </td>

                        <td>{row.note}</td>

                        <td>
                          {new Date(row.created_at).toLocaleString("id-ID")}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
